export { default as ItemsTab } from './ItemsTab';
import { pipe } from 'fp-ts/function';
import { withAsyncContainer } from '@mews-commander/ui';
import inject from './inject';
import ItemsTab from './ItemsTab';

export default pipe(ItemsTab, withAsyncContainer, inject);
